import * as React from 'react';
import Typography from '@material-ui/core/Typography';
import TabNavigation from '../../shared/components/TabNavigation';
import SettingsIcon from '@material-ui/icons/Settings';
import PeopleIcon from '@material-ui/icons/People';
import CommunityIcon from '@material-ui/icons/GroupWork';
import NotificationsIcon from '@material-ui/icons/Notifications';
import OrganizationGeneralSettings from './OrganizationSettings';
import OrganizationNotificationChannels from "./OrganizationNotificationChannels";
import OrganizationUsers from './OrganizationUsers'
import {identity} from '../../core/auth/identityAuth';
import Entity from '../models/Entity';
import BreadCrumb from '../../shared/components/BreadCrumb'
import HttpService from '../../../modules/core/services/HttpService';
import SubscriptionService from '../../consumer/services/SubscriptionService';
import { DialogContentText, TextField, Divider } from '@material-ui/core';
import ConfirmationModal from 'src/modules/shared/components/ConfirmationModal';
import Address from '../models/Address';
import OrganizationUserDetail from "./OrganizationUserDetail";
import OrganizationNotificationDetail from "./OrganizationNotificationChannelDetail";
import OrganizationCommunities from "./OrganizationCommunities"
import LegacyOrganizationNotificationDetail from "./LegacyOrganizationNotificationDetail";
import LegacyOrganizationNotifications from "./LegacyOrganizationNotifications";
import Asset from 'src/modules/consumer/models/Asset';
import { NotificationSystem2AssetIds } from "../../shared/constants";

const httpService = HttpService.Instance;
const subscriptionService = SubscriptionService.Instance;

interface IState {
  entity: Entity,
  subscribedAssets: Asset[],
  organizationSwitchConfirm: boolean,
  loading: boolean
}

class OrganizationOverview extends React.Component<any, IState> {

  constructor(props: any) {
    super(props);
    this.state = {
      entity: new Entity(),
      subscribedAssets: [],
      organizationSwitchConfirm: false,
      loading: true
    };
  }

  public componentDidMount() {
    httpService.get(process.env.REACT_APP_API_URL + 'entity/' + encodeURI(identity["nxt:entity:id"]))
      .then(response => response.json())
      .then(data => {
        const entity = data
        if (!this.state.entity.addresses) {
          entity.addresses = []
        }
        if (entity.addresses.length < 1) {
          entity.addresses.push(new Address())
        }
        this.setState({ ...this.state, entity, loading: false })
      })

      subscriptionService.getAssetSubscriptions()
        .then(subscribedAssets => {
          this.setState({ subscribedAssets });
        });
  }

  public render() {
      const tabs = [
          {
              icon: <SettingsIcon/>,
              label: 'ORGANIZATION',
              page: {
                  component: OrganizationGeneralSettings,
                  routeAffix: 'settings',
              }
          },
          {
              icon: <PeopleIcon/>,
              label: 'USERS',
              page: {
                  component: OrganizationUsers,
                  routeAffix: 'users'
              },
              subPages: [
                  {
                      component: OrganizationUserDetail,
                      routeAffix: 'add',
                  },
                  {
                      component: OrganizationUserDetail,
                      routeAffix: ':userId',
                  }
              ]

          },
          {
            icon: <CommunityIcon/>,
            label: 'COMMUNITY MEMBERSHIPS',
            page: {
                component: OrganizationCommunities,
                routeAffix: 'community-membership'
            },
            subPages: [
                {
                    component: OrganizationUserDetail,
                    routeAffix: ':communityMembershipId',
                }
            ]
          },
          {
              icon: <NotificationsIcon />,
              label: 'NOTIFICATIONS',
              page: {
                  component: LegacyOrganizationNotifications,
                  routeAffix : 'notifications'
              },
              subPages:[
                  {
                    component: LegacyOrganizationNotificationDetail,
                    routeAffix: 'add'
                  },
                  {
                      component: LegacyOrganizationNotificationDetail,
                      routeAffix: ':notificationId'
                  }
              ]
          }
      ];

      if (this.state.subscribedAssets.some(asset => NotificationSystem2AssetIds.includes(asset.id))) {
        tabs.push({
            icon: <NotificationsIcon />,
            label: 'NOTIFICATION CHANNELS 2.0',
            page: {
                component: OrganizationNotificationChannels,
                routeAffix : 'notificationchannels'
            },
            subPages:[
                {
                  component: OrganizationNotificationDetail,
                  routeAffix: ':channelType/add'
                },
                {
                  component: OrganizationNotificationDetail,
                  routeAffix: ':channelType/:notificationChannelId'
                }
            ]
        })
      }

    return (
      <div>
        <Typography variant='title'>
          {this.state.entity.name}
        </Typography>
        <Typography color="textSecondary" gutterBottom={true}>
          <BreadCrumb
            value='Console'
            to='/'
          />
          Organization
        </Typography>
        {!this.state.entity.isSingleUserEntity &&
          <TabNavigation
            tabs={tabs}
            history={this.props.history}
            routeParm={this.props.match.params.tab}
          />
        }
        {this.state.entity.isSingleUserEntity &&
          <div>
            <Typography gutterBottom={true}>
              You are registered as single user.
            </Typography>

          </div>
        }
        {!this.state.loading &&
          <ConfirmationModal
            open={this.state.organizationSwitchConfirm}
            onClose={() => this.setState({ ...this.state, organizationSwitchConfirm: false })}
            onConfirm={() => {
              const entity = { ...this.state.entity, isSingleUserEntity: false }
              httpService.put(process.env.REACT_APP_API_URL + 'entity/' + encodeURI(identity["nxt:entity:id"]), entity, { successMessage: "Switched to organization" }).then((response: Response) => {
                if (response.ok) {
                  this.setState(
                    { ...this.state, entity }
                  )
                }
              })
            }}
          >
            <DialogContentText className="padding-bottom-15">Are you sure you want to create an organization? Fill in the required information and press "YES" to make the switch. (This action is irreversible)  </DialogContentText>
            <Divider />
            <TextField
              fullWidth={true}
              required={true}
              name="name"
              label="ORGANIZATION NAME"
              value={this.state.entity.name}
              onChange={(e: any) => {
                const entity = this.state.entity
                entity.name = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
            <TextField
              fullWidth={true}
              required={true}
              name="vat"
              label="VAT"
              value={this.state.entity.vat}
              onChange={(e: any) => {
                e.target.value = e.target.value.replace(/[^a-zA-Z0-9 ]/, '').toUpperCase();
                const entity = this.state.entity
                entity.vat = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
            <TextField
              fullWidth={true}
              required={true}
              name="street"
              label="STREET"
              value={this.state.entity.addresses[0].street}
              onChange={(e: any) => {
                const entity = this.state.entity
                entity.addresses[0].street = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
            <TextField
              fullWidth={true}
              required={true}
              name="streetNumber"
              label="NUMBER"
              value={this.state.entity.addresses[0].streetNumber}
              onChange={(e: any) => {
                const entity = this.state.entity
                entity.addresses[0].streetNumber = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
            <TextField
              fullWidth={true}
              required={true}
              name="postalCode"
              label="ZIP"
              value={this.state.entity.addresses[0].postalCode}
              onChange={(e: any) => {
                const entity = this.state.entity
                entity.addresses[0].postalCode = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
            <TextField
              fullWidth={true}
              required={true}
              name="city"
              label="CITY"
              value={this.state.entity.addresses[0].city}
              onChange={(e: any) => {
                const entity = this.state.entity
                entity.addresses[0].city = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
            <TextField
              fullWidth={true}
              required={true}
              name="country"
              label="COUNTRY"
              value={this.state.entity.addresses[0].country}
              onChange={(e: any) => {
                const entity = this.state.entity
                entity.addresses[0].country = e.target.value
                this.setState({ ...this.state, entity })
              }}
              margin="normal"
            />
          </ConfirmationModal>
        }
      </div>
    )
  };
}

export default OrganizationOverview




// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationOverview.tsx